import { put, takeEvery, call, delay } from 'redux-saga/effects';
import ActionTypeConstants from "helpers/ActionTypeConstants";
import { actionApiCall } from "helpers/api/ApiCalls";

function* addNewOrgWizardSaga({payload}) {
    try {
        const apiResponse = yield call(actionApiCall, {
            actionType: ActionTypeConstants.SUBMIT_NEW_ORG_SAGA,
            data: payload
        });

        yield delay(1000);
        if (apiResponse.res.data.response === 200) {
            yield put({
                type: ActionTypeConstants.CREATE_ORG_SUCCESS,
                payload: {
                    data: apiResponse.res.data.data,
                    message: "The new organization is saved successfully.",
                    color: "success"
                }
            });
        } else {
            yield put({
                type: ActionTypeConstants.CREATE_ORG_FAILURE,
                payload: {
                    message: apiResponse.res.data.message || ["Creating organization failed!"],
                    color: "danger"
                }
            });
        }
    } catch (err) {
        yield put({
            type: ActionTypeConstants.CREATE_ORG_FAILURE,
            payload: {
                message: ["Server error. Please try again later."],
                color: "danger"
            }
        });
    }
}

export default function*() {
    yield takeEvery(ActionTypeConstants.SUBMIT_NEW_ORG_SAGA, addNewOrgWizardSaga);
}
